import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import { MusterChitReport } from "./pages";

export const MusterChitReportRoute = ({ match }) => (
  <Fragment>
    <Route exact path={`${match.path}`} component={MusterChitReport} />
  </Fragment>
);
